export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/go-icon.svg?d23a4b881abf2128ae246ab1ef33636a";